export class SinUtils {
  // Validates a Canadian Social Insurance Number (SIN)
  // Must be exactly 9 digits, and passes the Luhn algorithm check
  static isValidSIN(sin: string | number): boolean {
    const sinStr = sin.toString().replace(/\s+/g, '');
    if (!/^\d{9}$/.test(sinStr)) {
      return false;
    }
    const digits = sinStr.split('').map(Number);
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      let digit = digits[i];
      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
    }
    return sum % 10 === 0;
  }
}
